import React, { useState, useEffect } from "react";

import "./toggle.scss";
const Toggle = ({ options, input, imageMode }) => {
  const [selectedOption, setSelectedOption] = useState(options[0]);

  useEffect(() => {
    input.onChange(selectedOption);
  }, [selectedOption]);

  useEffect(() => {
    if (!input.value) {
      input.onChange(options[0]);
    } else {
      setSelectedOption(input.value);
      input.onChange(input.value);
    }
  }, [input.value]);

  const changeHandler = (e) => {
    setSelectedOption(() => e);
  };

  return (
    <div className="toggleField">
      {options.map((element, index) => (
        <label
          className={`${
            element.value === selectedOption.value
              ? "optionItem active"
              : "optionItem"
          }`}
          key={index}
          htmlFor={`${input.name}${index + 1}`}
          onClick={() => changeHandler(element)}
        >
          {!imageMode && element.text}
          {imageMode && (
            <img width='25' height='25' src={element.imgUrl} alt="" />
          )}
        </label>
      ))}
    </div>
  );
};

export default Toggle;
